import { useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"

const featuredKeys = [
  '1451',
  '1428',
  '2326',
  '2228',
  '2081',
  '2086',
  '1540',
  '2039',
  '2065',
  '2339'
];

const usePhotogallery = (featured) => {
  const { allFile } = useStaticQuery(graphql`{
    allFile(filter: { relativePath: { regex: "/^photogallery\/.*/"}}) {
      edges {
        node {
          name
          publicURL
          childImageSharp {
            thumb: fluid(maxWidth: 340, maxHeight: 220, cropFocus: NORTH) {
              ...GatsbyImageSharpFluid_withWebp
            },
            slider: fluid(maxWidth: 650, maxHeight: 416, cropFocus: NORTH) {
              ...GatsbyImageSharpFluid_withWebp
            },
          }
        }
      }
    }
  }`);

  const photos = useMemo(() => {
    const mapped = allFile.edges.map(edge => ({
      name: edge.node.name,
      imageUrl: edge.node.publicURL,
      slider: edge.node.childImageSharp.slider,
      thumb: edge.node.childImageSharp.thumb
    }));
    if (featured){
      return featuredKeys.map(key => mapped.find(item => item.name.includes(key)));
    }else{
      return mapped;
    }
  }, [allFile, featured]);

  return photos;
}

export default usePhotogallery;